import React from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectUsedTheme } from "_redux/slices/timeline/theme";
import { selectAllTimelineAreas } from "_redux/slices/timeline/timeline-areas";
import { Spacing } from "_styles";

const EmployeeZoneFilter = ({ value = "all", onChange, maxWidth = "100%" }) => {
  const usedTheme = useSelector(selectUsedTheme);
  const zones = useSelector(selectAllTimelineAreas) ?? [];

  const options = [
    { value: "all", label: "All" },
    ...zones.map((zone) => ({
      value: zone?._id,
      label: zone?.title ?? "Untitled",
    })),
  ];

  const renderLabel = (val) => options.find((opt) => opt.value === val)?.label ?? "Select Zone";

  return (
    <Dropdown onSelect={(next) => onChange?.(next ?? "all")} data-tippy-content="Filter by Zone">
      <Dropdown.Toggle
        variant={usedTheme.BUTTON_VARIANT}
        id="employee-zone-dropdown"
        style={{
          backgroundColor: usedTheme.BACKGROUND_COLOR,
          color: "gray",
          border: "1px solid",
          borderColor: usedTheme.BORDER_COLOR,
          width: maxWidth || "100%",
          height: Spacing.SCALE_38,
          textAlign: "left",
          padding: "8px",
          marginLeft: Spacing.SCALE_2,
          marginTop: Spacing.SCALE_4,
          marginBottom: Spacing.SCALE_4,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {renderLabel(value)}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR }}>
        {options.map((zone) => (
          <Dropdown.Item
            key={zone.value}
            style={{ color: usedTheme.TEXT_COLOR }}
            eventKey={zone.value}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = usedTheme.BORDER_COLOR;
              e.target.style.color = usedTheme.TEXT_COLOR;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = usedTheme.TEXT_COLOR;
            }}
          >
            {zone.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default EmployeeZoneFilter;
